/* eslint-disable @typescript-eslint/no-explicit-any */
// Third-party tag loaders, as the legacy `src/analytics-scripts/*.js` had them. Production builds only.
import { environment } from '../../../environments/environment';

const w = window as any;

function loadScript(src: string) {
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function googleAnalytics() {
  if (environment.ENV_NAME === 'production') {
    w.GoogleAnalyticsObject = 'ga';
    w.ga =
      w.ga ||
      function (...args: unknown[]) {
        (w.ga.q = w.ga.q || []).push(args);
      };
    w.ga.l = Date.now();
    loadScript('https://www.google-analytics.com/analytics.js');
    w.ga('create', environment.GA_TRACKING_ID, 'auto');
    w.ga('send', 'pageview');
  } else if (environment.ENV_NAME === 'staging') {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${environment.GA_TRACKING_ID}`);
    w.dataLayer = w.dataLayer || [];
    w.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      w.dataLayer.push(arguments);
    };
    w.gtag('js', new Date());
    w.gtag('config', environment.GA_TRACKING_ID);
  }
}

function googleTagManager(containerId: string) {
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  loadScript(`https://www.googletagmanager.com/gtm.js?id=${containerId}`);
}

function facebookPixel() {
  if (w.fbq) {
    return;
  }
  const fbq: any = (w.fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  });
  w._fbq = w._fbq || fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  loadScript('https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', environment.FACEBOOK_PIXEL);
}

function intercom() {
  w.intercomSettings = { app_id: environment.INTERCOM_APP_ID };
  if (typeof w.Intercom === 'function') {
    w.Intercom('reattach_activator');
    w.Intercom('update', w.intercomSettings);
    return;
  }
  const stub: any = (...args: unknown[]) => stub.c(args);
  stub.q = [];
  stub.c = (args: unknown) => stub.q.push(args);
  w.Intercom = stub;
  window.addEventListener('load', () => loadScript(`https://widget.intercom.io/widget/${environment.INTERCOM_APP_ID}`));
}

export function installProductionScripts() {
  googleAnalytics();
  // two containers, as before: the marketing one and the one the dashboard shares (`GTM_ID`)
  googleTagManager(environment.GTM);
  if (environment.GTM_ID) {
    googleTagManager(environment.GTM_ID);
  }
  facebookPixel();
  intercom();
}
